<template>
  <div class="dashboardAvailableObjectsSummary">
    <ReportsDashboardMetric :value="rate" legend="utleiegrad" format="percent" color="secondary" />
    <div class="dashboardAvailableObjectsSummary__grid">
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardAvailableObjectsTotals.vacantNow"
        legend="ledig(e)"
        :color="getDashboardAvailableObjectsTotals.vacantNow > 0 ? 'red' : 'secondary'"
        small
      />
      <ReportsDashboardMetric
        class="count"
        :value="getDashboardAvailableObjectsTotals.count"
        legend="totalt"
        color="secondary"
        small
      />
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button class="btn btn-sm btn-outline-secondary" @click="goToOverviewRentalObjects">Til rapport</button>
    </div>
  </div>
</template>

<script>
import ReportsDashboardMetric from '@/components/reports/dashboard/ReportsDashboardMetric';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardAvailableObjectsSummary',

  computed: {
    ...mapGetters('reports', ['getDashboardAvailableObjectsTotals']),
    rate() {
      const { vacantNow, count } = this.getDashboardAvailableObjectsTotals;

      return Math.round(((count - vacantNow) / count) * 100);
    },
  },
  components: {
    ReportsDashboardMetric,
  },
  methods: {
    goToOverviewRentalObjects() {
      this.$router.push({
        name: 'reports_overview_rental_object',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dashboardAvailableObjectsSummary__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
}
</style>
